export default "__VITE_ASSET__BFInMZX___"